import { Extension } from "@tiptap/core";

export const Enter = Extension.create({
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.setHardBreak(),
    };
  },
});
